import { Model } from "@vuex-orm/core";
import Downlink from "./downlink";
import Measure from "./measure";
import TemperatureCorrection from "./temperature_correction";

export default class Device extends Model {
  static entity = "devices";

  static fields() {
    return {
      id: this.attr(null),
      uid: this.attr(null),
      last_comm: this.attr(null),
      voltage: this.attr(0),
      gain: this.attr(0),
      offset: this.attr(0),
      latest_measure: this.attr(null),

      downlink: this.hasOne(Downlink, "device_id"),
      measures: this.hasMany(Measure, "device_id"),
      temperature_correction: this.hasOne(TemperatureCorrection, "device_id"),
    };
  }
}
